// Sélectionner toutes les descriptions
const descriptions = document.querySelectorAll('.collection-hero__description');

// Fonction pour masquer le texte après 3 lignes
function truncateText(element, lines = 3) {
  const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
  const maxHeight = lineHeight * lines;

  if (element.scrollHeight > maxHeight) {
    const originalText = element.innerHTML;

    // Masquer le texte avec un bouton "Voir plus"
    element.style.maxHeight = `${maxHeight}px`;
    element.style.overflow = 'hidden';
    element.style.position = 'relative';

    // Créer le bouton "Voir plus"
    const seeMoreBtn = document.createElement('button');
    seeMoreBtn.textContent = 'Voir plus';
    seeMoreBtn.style.marginTop = '10px';
    seeMoreBtn.style.cursor = 'pointer';
    seeMoreBtn.style.border = 'none';
    seeMoreBtn.style.textDecoration = 'underline';
    seeMoreBtn.style.background = 'none';
    seeMoreBtn.style.fontSize = '1em';

    // Ajouter l'événement au bouton
    seeMoreBtn.addEventListener('click', () => {
      if (element.style.overflow === 'hidden') {
        element.style.maxHeight = 'none';
        element.style.overflow = 'visible';
        seeMoreBtn.textContent = 'Voir moins';
      } else {
        element.style.maxHeight = `${maxHeight}px`;
        element.style.overflow = 'hidden';
        seeMoreBtn.textContent = 'Voir plus';
      }
    });

    // Ajouter le bouton après le texte
    element.insertAdjacentElement('afterend', seeMoreBtn);
  }
}

// Appliquer la fonction à chaque description
descriptions.forEach((description) => truncateText(description));